import { render, staticRenderFns } from "./ModalHirePurchase.vue?vue&type=template&id=1670c146&scoped=true"
import script from "./ModalHirePurchase.vue?vue&type=script&lang=js"
export * from "./ModalHirePurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670c146",
  null
  
)

export default component.exports